import { Link } from "react-router-dom";
import { Home, Building2, KeyRound, ArrowRight } from "lucide-react";

const CARDS = [
  { icon: Home, title: "I'm a landlord", body: "Know exactly what's due in your nation, get reminded, and prove it when asked.", to: "/signup", cta: "Start free trial", testid: "audience-landlord" },
  { icon: Building2, title: "I'm a letting agent", body: "One Agency plan covers every landlord you manage. Act on their behalf, see everything in one view.", to: "/signup?plan=agency", cta: "See the Agency plan", testid: "audience-agent", accent: true },
  { icon: KeyRound, title: "I'm a tenant", body: "Your landlord can share a private link so you can see the property's certificates and report repairs.", to: "/guides/england", cta: "What should my landlord have?", testid: "audience-tenant" },
];

export default function AudienceSplit() {
  return (
    <div className="grid md:grid-cols-3 gap-4" data-testid="audience-split">
      {CARDS.map((c, i) => (
        <Link key={c.title} to={c.to} data-testid={c.testid} className={`group rounded-3xl p-6 border transition-all hover:-translate-y-1 animate-fade-up ${c.accent ? "bg-emerald-brand text-white border-emerald-brand shadow-xl shadow-emerald-900/20" : "bg-card border-border hover:border-navy/30"}`} style={{ animationDelay: `${i * 90}ms` }}>
          <span className={`grid h-11 w-11 place-items-center rounded-2xl ${c.accent ? "bg-white/15" : "bg-navy text-white"}`}><c.icon size={20} /></span>
          <h3 className="mt-4 font-heading text-lg font-bold">{c.title}</h3>
          <p className={`mt-2 text-sm ${c.accent ? "text-white/85" : "text-muted-foreground"}`}>{c.body}</p>
          <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold">{c.cta} <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" /></span>
        </Link>))}
    </div>
  );
}
